import type { ReactNode } from "react";
import cx from "classnames";

const WARNING = "warning";
const INFO = "info";

interface Props {
  type?: "warning" | "info";
  children: ReactNode;
}

export default function Message({ type, children }: Props) {
  const className = cx({
    Message: true,
    "Message--warning": type === WARNING,
    "Message--info": type === INFO,
  });

  return <div className={className}>{children}</div>;
}
